import '../../styles/bootstrap-custom.sass';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'epic-games-footer/lib/epicGamesFooter.epic-games-footer.css';
import 'react-day-picker/lib/style.css';
